import type { ElementType } from 'react';
import { Button, styled } from '@mui/material';

import { rem } from '../dashboardPanelTokens';

/**
 * `styled()` erases MUI's polymorphic `component` overload, so a styled Button
 * rendered as a router Link stops type-checking. Re-declaring the two props we
 * use keeps the call sites honest without casting them away.
 */
interface AsLink {
  readonly component?: ElementType;
  readonly to?: string;
}

/**
 * The tile's own action pair.
 *
 * Deliberately not `SolidButton` from the quick-action rail: that one is a
 * full-width card CTA with wide padding and tracking, and two of them sitting
 * inline in this tile's header row dwarf the heading beside them. Same colours,
 * smaller frame.
 */
export const TilePrimaryButton = styled(Button)<AsLink>(({ theme }) => ({
  flexShrink: 0,
  padding: `${rem(8)} ${rem(14)}`,
  minWidth: 0,
  fontSize: rem(13),
  fontWeight: 600,
  lineHeight: 1.4,
  letterSpacing: 0,
  textTransform: 'none',
  color: theme.palette.common.white,
  backgroundColor: theme.palette.common.azureBlue,

  '&:hover': {
    backgroundColor: theme.palette.common.surfaceAction,
  },
}));

export const TileSecondaryButton = styled(Button)<AsLink>(({ theme }) => ({
  flexShrink: 0,
  padding: `${rem(8)} ${rem(12)}`,
  minWidth: 0,
  fontSize: rem(13),
  fontWeight: 600,
  lineHeight: 1.4,
  letterSpacing: 0,
  textTransform: 'none',
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.common.surfaceDisabled}`,

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));
